<template>
  <div class="polar-club">
      <div class="polar-club-main">
          <p>
              极地俱乐部<br>一个极致的兴趣社区
          </p>
          <div class="poloar-club-button" @click='eshow'>
              <p class="poloar-club-button-name" >
                  去看看
              </p>
              <img :src="RightTriangle" alt="">
          </div>
      </div>
      <Expect v-show='expectshow'></Expect>
  </div>
</template>

<script>
import RightTriangle from '@/assets/img/right-triangle.png'
import Expect from '@/components/warning/expect'
export default {
  name: 'PolarClub',
  data () {
    return {
      RightTriangle,
      expectshow: false
    }
  },
  components: {
    Expect
  },
  methods: {
    eshow () {
      // this.expectshow = true
      // setTimeout(() => { this.expectshow = false }, 1000)
      this.$router.push({
        path: '/club'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.polar-club {
    width: 100%;
    height: 388px;
    margin-top: 60px;
    background: url('../../assets/img/polar-club.png') no-repeat center;
    background-size: cover;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}
.polar-club-main {
    width: 647px;
    height: 235px;
    background: rgba($color: #004889, $alpha: 0.4);
    display: flex;
    align-items: center;
    flex-direction: column;
    p {
        font-size: 42px;
        color: #fff;
        text-align: center;
        font-weight: bold;
        line-height: 56px;
        margin-top: 30px;
    }
    .poloar-club-button {
        width: 162px;
        height: 44px;
        border: 1px solid #fff;
        border-radius: 5px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin-top: 20px;
        &:hover {
            background: rgba($color: #0a06f5, $alpha: 0.1)
        }
        p {
            line-height: 1;
            font-size: 16px;
            margin: 0;
        }
        img {
            position: absolute;
            right: 18px;
            z-index: 1000;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/polarClub.vue